import { render, staticRenderFns } from "./ScreeningManage.vue?vue&type=template&id=75edef6e&"
import script from "./ScreeningManage.vue?vue&type=script&lang=js&"
export * from "./ScreeningManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports